module.exports = __webpack_public_path__ + "img/23d9c96.png";